import Observer from "../../services/helpers/Observer"
import { v4 as uuidv4 } from 'uuid';
import {KEY_GROUP} from "@frontend/constants/templates-field-prefixes";

export const EVENTS = {
    UPDATED: 'updated',
    ADDED: 'added',
    REMOVED: 'removed'
}

export default class GroupFields extends Observer {

    items = []

    setItems(items) {
        this.items = items
    }

    add(group) {
        group.id = KEY_GROUP + uuidv4()
        this.items.push(group)

        this.dispatch(EVENTS.UPDATED, this)
        this.dispatch(EVENTS.ADDED, { group })

        return group
    }

    remove(id) {
        this.items = this.items.filter(group => group.id !== id)

        this.dispatch(EVENTS.UPDATED, this)
        this.dispatch(EVENTS.REMOVED, { id })
    }

    getGroupByFieldId(fieldId) {
        return this.items.find(group => group.fields.includes(fieldId))
    }

    getItems() {
        return this.items
    }
}